module.exports = __webpack_public_path__ + "static/media/f_hairstyle_straight_short_front.ea48fc7e.png";